import { forwardRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useRouter } from '../../hooks/useRouter.js';

export const withRouter = (Component, other) => {
  return forwardRef((props, ref) => {
    const { wrappedComponentRef, ...otherProps } = props;
    const history = useRouter();
    const location = useLocation();
    const params = useParams();

    return (
      <Component
        ref={wrappedComponentRef}
        {...otherProps}
        history={history}
        location={location}
        params={params}
      />
    );
  });
};
